import React, { useEffect, useState } from 'react'
import history from '../../../../history'
import {
  checkAccess,
  getAiVideoAccessInfo
} from '../../../../services/api/aiVideoGeneration'

/**
Creates buttons based on user permissions and organization settings.
@param {object} props - Props object containing t, user info, and organization info.
@returns {JSX.Element} - Returns a JSX element containing WorkshopCreateButton components. */
function CreateButtons(props) {
  const {
    t,
    user: {
      info: { organization, isSuperAdmin, isAdmin, active_organization_id }
    }
  } = props

  const hasAdminAccess = (isSuperAdmin || isAdmin) && active_organization_id

  const enableCreateMaze =
    organization && organization.enable_maze && hasAdminAccess
  const enableCreateShareSphere =
    organization && organization.enable_sharesphere && hasAdminAccess

  const [showGenVideoAiBtn, setShowGenVideoAiBtn] = useState(false)

  useEffect(() => {
    manageAccess()
  }, [])

  const manageAccess = async () => {
    try {
      const res = await checkAccess()
      const accessInfo = getAiVideoAccessInfo(res)
      setShowGenVideoAiBtn(accessInfo.hasAccess)
    } catch (error) {
      console.error('Failed to check AI video access:', error)
      setShowGenVideoAiBtn(false)
    }
  }

  return (
    <>
      <WorkshopCreateButton
        onClickPath="/course-create"
        title={t('workshop:new_course')}
      />

      {showGenVideoAiBtn && (
        <WorkshopCreateButton
          onClickPath="/video-create"
          title={t('v4:generate_video_text')}
        />
      )}
      <WorkshopCreateButton
        onClickPath="/scorm-create"
        title={t('v4:upload_scorm_course')}
      />
      <WorkshopCreateButton onClickPath="/events" title={t('new_event')} />
      {enableCreateMaze && (
        <WorkshopCreateButton
          onClickPath="/maze/create"
          title={t('v4:new_maze')}
        />
      )}
      <WorkshopCreateButton
        onClickPath="/skill-journey"
        title={t('v4:new_skill_journey')}
      />
      <WorkshopCreateButton
        onClickPath="/channel"
        title={t('v3:create_a_channel')}
      />
      {enableCreateShareSphere && (
        <WorkshopCreateButton
          onClickPath="/share-sphere/list"
          title={t('v4:shareSphere_game')}
        />
      )}
      {active_organization_id && active_organization_id === 524 && (
        <WorkshopCreateButton
          onClickPath="/image-creator"
          title={t('v4:imageCreatorTitle')}
        />
      )}
      <WorkshopCreateButton
        onClickPath="/podcast-create"
        title={t('v4:new_discussion_room')}
      />
      <WorkshopCreateButton
        onClickPath="/quest-list"
        title={t('quest:quest_title')}
      />
    </>
  )
}

function WorkshopCreateButton({ onClickPath, title }) {
  return (
    <div className="button-plus" onClick={() => history.push(onClickPath)}>
      <div className="button-plus__icon" />
      <div className="button-plus__text">{title}</div>
    </div>
  )
}

export default CreateButtons
